import { render, staticRenderFns } from "./printPriceTag.vue?vue&type=template&id=551fbd59&"
import script from "./printPriceTag.vue?vue&type=script&lang=js&"
export * from "./printPriceTag.vue?vue&type=script&lang=js&"
import style0 from "./printPriceTag.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports